export default __webpack_public_path__ + "static/media/triangle.c0c55454.png";